/** Highest rebate / top-up percent the editor accepts. */
export const MAX_REBATE_PERCENT = 999;

/**
 * Normalises a tier's rebate / top-up percent: null, undefined, non-numeric and negative
 * values all become 0. Use it when reading from the API, rendering, and before saving, so
 * a missing percent never shows as "-", "null%" or a negative number.
 */
export function toRebatePercent(value: unknown): number {
  if (value === null || value === undefined || value === "") return 0;
  const n = Number(value);
  if (Number.isNaN(n) || n < 0) return 0;
  return n;
}
